import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./Pages/Home";
import DownloadPage from "./Pages/DownloadPage";
import Terms from "./Pages/Terms";
import Contactus from "./Pages/Contactus";
import PrivacyPolicies from "./Pages/PrivacyPolicies";
import { Apicontext } from "./context/ContextApi";
import { useContext } from "react";

const App = () => {
  const { theme } = useContext(Apicontext);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
      errorElement: <div>There is an error in this page!</div>,
    },
    {
      path: "/info",
      element: <DownloadPage />,
      errorElement: <div>There is an error in this page!</div>,
    },
    {
      path: "/Terms",
      element: <Terms />,
      errorElement: <div>There is an error in this page!</div>,
    },
    {
      path: "/Contactus",
      element: <Contactus />,
      errorElement: <div>There is an error in this page!</div>,
    },
    {
      path: "/PrivacyPolicies",
      element: <PrivacyPolicies />,
      errorElement: <div>There is an error in this page!</div>,
    },
  ]);
  return (
    <div className={theme ? "dark" : ""}>
      <RouterProvider router={router} />
    </div>
  );
};
export default App;
